import React, { useState } from 'react';
import axios from 'axios';
import api from '../../api';
import { useNavigate } from 'react-router-dom';
import './UsersFeedback.css';
import useBlockCheck from '../../hooks/useBlockCheck';
import { useAuth } from '../../context/AuthContext';
import { useSocket } from '../../context/SocketContext';

const UsersFeedback = () => {
  const { token } = useAuth();
  useBlockCheck('user');
  const navigate = useNavigate();
  const { socket } = useSocket();

  const [formData, setFormData] = useState({
    title: '',
    description: '',
  });
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title || !formData.description) {
      setErrorMessage('Please select a feedback type and provide your detailed feedback.');
      return;
    }

    try {
      const response = await axios.post(api.feedback, { ...formData, role: 'student' }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      // Emit socket event after successful submission
      if (socket) {
        socket.emit('feedbackSubmitted', {
          feedback: formData,
          message: 'New feedback submitted',
        });
      }

      setSuccessMessage(response.data.message || 'Your feedback has been submitted successfully!');
      setErrorMessage('');
      setFormData({ title: '', description: '' });

      setTimeout(() => navigate('/home'), 1500);
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'An unexpected error occurred. Please try again.');
      setSuccessMessage('');
    }
  };

  return (
    <div className="feedback-container">
      <button className="u-f-close-button" onClick={() => navigate('/home')} aria-label="Close Feedback Form">×</button>

      {/* <h2 className="feedback-title">We Value Users Feedback</h2> */}
      <h2 className="feedback-title">We’d like to hear your Feedbacks</h2>
      
      {successMessage && <div className="feedback-success-message">{successMessage}</div>}
      {errorMessage && <div className="feedback-error-message">{errorMessage}</div>}

      <form onSubmit={handleSubmit} className="feedback-form">
        <div className="feedback-form-group">
          <label htmlFor="title" className="feedback-label">Feedback Category</label>
          <select
            className="feedback-input"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Category --</option>
            <option value="Complaint">Complaint</option>
            <option value="Compliment">Compliment</option>
            <option value="Suggestion">Suggestion</option>
            <option value="Improvement">Improvement</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="feedback-form-group">
          <label htmlFor="description" className="feedback-label">Your Feedback</label>
          <textarea
            className="feedback-textarea"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Please describe your experience or suggestion..."
            required
          />
        </div>

        <div className="btn-con">
          <button type="submit" className="u-feedback-submit-button">Submit Feedback</button>
        </div>
      </form>
    </div>
  );
};

export default UsersFeedback;
